import { useFlags } from '@missionlabs/feature-flags'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { SubNavLink, SubNavMenu } from 'shared/components/SubNav'
import { Features, useHasClientFeature } from 'shared/hooks/useHasClientFeature'
import { useHasFeature } from 'shared/hooks/useHasFeature'

export interface AdminSidebarProps {}

export const AdminSidebar: FC<AdminSidebarProps> = () => {
    const flags = useFlags(['billing', 'call_recording', 'subscription'])
    const { t } = useTranslation()

    const isMenuClientEnabled = useHasClientFeature(Features.menus)
    const isTeamClientEnabled = useHasClientFeature(Features.teams)
    const isWhatsAppEnabled = useHasFeature(Features.whatsapp)

    return (
        <SubNavMenu title={t('admin.title')}>
            <SubNavLink label={t('admin.users.title')} page="/admin/users" />
            {isTeamClientEnabled && (
                <SubNavLink label={t('admin.teams.title')} page="/admin/teams" />
            )}
            <SubNavLink label={t('admin.numbers.title')} page="/admin/numbers" />
            {isMenuClientEnabled && (
                <SubNavLink label={t('admin.menus.title')} page="/admin/menus" />
            )}
            {flags.call_recording.enabled && (
                <SubNavLink label={t('admin.callRecording.title')} page="/admin/call-recording" />
            )}
            <SubNavLink label={t('admin.blockedNumbers.title')} page="/admin/blocked-numbers" />
            <SubNavLink label={t('settings.speedDial.title')} page="/admin/speed-dial" />
            <SubNavLink label={t('admin.globalSettings.title')} page="/admin/global-settings" />
            <SubNavLink label={t('admin.activityLog.title')} page="/admin/activity-log" />
            {flags.billing.enabled && (
                <SubNavLink label={t('admin.billing.title')} page="/admin/billing" />
            )}
            {isWhatsAppEnabled && (
                <SubNavLink label={t('admin.whatsapp.title')} page="/admin/whatsapp" />
            )}
            {flags.subscription.enabled && (
                <SubNavLink label={t('admin.subscription.title')} page="/admin/subscription" />
            )}
        </SubNavMenu>
    )
}
